module.exports = __webpack_public_path__ + "static/media/logo-black.099c0275.png";